module.exports = __webpack_public_path__ + "img/scatter.5aaa5797.png";